module.exports = __webpack_public_path__ + "static/media/Q7-3.d064af37.jpg";